import { Col, Nav, NavLink } from "reactstrap";
import { NavOrganizationProps } from "../../../../../Types/ContactType";
import { OrganizationList } from "../../../../../Data/Applications/Contacts/Contacts";
import { Href } from "../../../../../Constants/Constants";
import { H6, Image, P } from "../../../../../AbstractElements";
import { dynamicImage } from "../../../../../Utils";

export const NavOrganization:React.FC<NavOrganizationProps> = ({ orgActiveTab, setOrgActiveTab }) => {
  return (
    <Col xl="4" md="5" className="xl-50">
      <Nav className="flex-column" pills>
        {OrganizationList.map((item) => (
          <NavLink
            key={item.id}
            href={Href}
            className={orgActiveTab === item.id ? "active" : ""}
            onClick={() => {
              setOrgActiveTab(item.id);
            }}
          >
            <div className="d-flex">
              <Image className="img-50 img-fluid m-r-20 rounded-circle" src={dynamicImage(`${item.avatar}`)} alt="" />
              <div className="flex-grow-1">
                <H6>{item.name}</H6>
                <P>{item.email}</P>
              </div>
            </div>
          </NavLink>
        ))}
      </Nav>
    </Col>
  );
};
